/* ==========================================================================
   SelectPanel > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'SelectPanel',
    init: true,
    start: true,
    css: {
        self: 'select-panel',
        panel: 'select-panel__panel',
        hidden: 'is-hidden'
    },
    type: {
        input: 'select-panel-input',
        panel: 'select-panel-panel',
        select: 'select-panel-select'
    },
    hooks: {
        panelContent: 'data-ui-panel-content'
    }
};

module.exports = () => config;
